// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__SOn8+","swiper-animation":"Slider_swiper-animation__n6lXS","swipe":"Slider_swipe__r1Qnc"};